var _classCallCheck = require("/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var Packet = function Packet() {
  "use strict";

  _classCallCheck(this, Packet);

  this.cmd = null;
  this.retain = false;
  this.qos = 0;
  this.dup = false;
  this.length = -1;
  this.topic = null;
  this.payload = null;
};

module.exports = Packet;